<template>
  <footer>
    <div class="bg-gray-40 p-4">
      <div class="container">
        <div v-show="userCountry.country_code == 'de' && userCountry.language_code == 'de'"
             class="row mb-3 justify-content-center">
          <div class="col-12 col-lg-5">
            <div class="input-group w-100">
              <label class="mr-3 pt-2">{{ __('lang.kwl.footer.newsletter') }}</label>
              <b-form-input type="text" class="form-control rounded-left" v-model="email" id="input_email"
                            :placeholder="__('lang.footer.newsletter.placeholder.email')"
                            autocomplete="email"></b-form-input>
              <div class="input-group-append">
                <a id="heliosNewsletterModalOpen" role="button" data-toggle="modal"
                   class="btn btn-primary w-100 border-0" data-target="#newsletterModal" @click="openNewsletterForm">
                  <span class="sr-only" data-toggle="modal"
                        data-target="#newsletterModal">{{ __('lang.kwl.footer.newsletter_abo') }}</span>
                  <svg class="icon m-0">
                    <use xlink:href="/assets/img/icon-sprite.svg#global.mail"
                         xmlns:xlink="http://www.w3.org/1999/xlink "></use>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <nav class="bg-gray-80 py-2 small">
      <div class="container">
        <div class="row align-items-center">
          <ul class="navbar-nav flex-md-row col-12 col-md-8">
            <li class="nav-item text-white ml-3 py-2">&copy; {{ new Date().getFullYear() }} {{
                __('lang.kwl.footer.company_name')
              }}
            </li>
            <li class="nav-item ml-3">
              <a class="nav-link text-white" rel="noopener" target="_blank"
                 href="https://www.heliosventilatoren.de/impressum">{{ __('lang.kwl.footer.impressum') }}</a>
            </li>
            <li class="nav-item ml-3">
              <a class="nav-link text-white" href="#" onclick="CCM.openWidget(); return false;">Cookies</a>
            </li>
            <li class="nav-item ml-3">
              <a class="nav-link text-white" rel="noopener" target="_blank"
                 href="https://www.heliosventilatoren.de/datenschutz">{{ __('lang.kwl.footer.data_protecten') }}</a>
            </li>
            <li class="nav-item ml-3">
              <a class="nav-link text-white" rel="noopener" target="_blank"
                 href="https://www.heliosventilatoren.de/allgemeine-geschaeftsbedingungen-agb">{{
                  __('lang.kwl.footer.agb')
                }}</a>
            </li>
          </ul>
          <ul class="navbar-nav flex-row col-12 col-md-4 pl-3 pl-md-0 justify-content-md-end">
            <li class="nav-item">
              <a class="nav-link text-white" rel="noopener" target="_blank"
                 href="https://www.facebook.com/HeliosVentilatoren/"
                 title="Helios Ventilatoren GmbH + Co. KG bei Facebook">
                <span class="sr-only">{{ __('lang.kwl.footer.facebook') }}</span>
                <svg class="icon icon-sm">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.social.facebook"
                       xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link text-white" rel="noopener" target="_blank"
                 href="https://www.instagram.com/heliosventilatoren"
                 title="Helios Ventilatoren GmbH + Co. KG bei Instagram">
                <span class="sr-only">{{ __('lang.kwl.footer.instagram') }}</span>
                <svg class="icon icon-sm">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.social.instagram"
                       xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link text-white" rel="noopener" target="_blank"
                 href="https://de.linkedin.com/company/helios-ventilatoren-gmbh-co-kg"
                 title="Helios Ventilatoren GmbH + Co. KG bei LinkedIn">
                <span class="sr-only">{{ __('lang.kwl.footer.linkedin') }}</span>
                <svg class="icon icon-sm">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.social.linkedin"
                       xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link text-white" rel="noopener" target="_blank"
                 href="https://www.xing.com/pages/heliosventilatorengmbh-cokg"
                 title="Helios Ventilatoren GmbH + Co. KG bei Xing">
                <span class="sr-only">{{ __('lang.kwl.footer.xing') }}</span>
                <svg class="icon icon-sm">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.social.xing"
                       xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link text-white" rel="noopener" target="_blank"
                 href="https://www.youtube.com/user/HeliosVentilatoren/"
                 title="Helios Ventilatoren GmbH + Co. KG bei Youtube">
                <span class="sr-only">{{ __('lang.kwl.footer.youtube') }}</span>
                <svg class="icon icon-sm">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.social.youtube"
                       xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div class="modal right fade" id="newsletterModal" tabindex="-1" role="dialog"
         aria-labelledby="newsletterModalLabel" aria-hidden="true">
      <newsletterform :email="email" ref="newsletterModal"></newsletterform>
    </div>
  </footer>
</template>

<script>
import log from '@services/logger/index'
import newsletterform from '@components/Footer/NewsletterForm.vue'

export default {
  components: {
    newsletterform,
  },
  data() {
    return {
      email: '',
      modalClasses: ['modal', 'right', 'fade'],
      dialogClasses: ['modal-dialog', 'modal_xl', 'shadow-lg', 'mx-0'],
    }
  },
  methods: {
    openNewsletterForm() {
      this.$refs.newsletterModal.setData()
    },
  },
  computed: {
    userCountry: {
      get() {
        return this.$store.state.User.country
      },
      set(value) {
        this.$store.commit('User/updateCountry', value)
      },
    },
  },
}
</script>
